import React, { memo } from "react";
import AerosNode from "./AerosNode";

export default memo(({ data, id, isConnectable, selected }) => (
  <AerosNode id={id} type="message" selected={selected} isConnectable={isConnectable}>
    {data.label}
  </AerosNode>
));
